import styled from "styled-components";
import BgGradient2 from "./assets/10.png";

export const IndexActionComponentMainDiv = styled.div`
  width: 100%;
  flex: 1;
  
  background-size: cover;
  background: rgb(0, 152, 243);

  background-repeat: no-repeat;
  border-radius: 12px;
  background-image: url(${BgGradient2});
  


  background-repeat: no-repeat;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
    border-radius: 12px;
      padding: 24px 8px;

    height: 376px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 80%;
    gap:18px;
  }
  .index-action-card-container {
    border-radius: 16px;
    backdrop-filter: blur(10px);
    height: auto;
    padding: 16px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    > div {
      display: flex;
      gap: 18px;
    }
  }
  .index-action-card-skeleton-holder {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: space-between;
  }
  .index-action-card-icon {
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    > svg {
      width: 24px;
      height: 24px;
    }
  }
  .index-action-card-text {
    > h3 {
      padding: 0px;
      margin: 0px;
    }
  }
  .index-action-card-skeleton {
    width: 60%;
    padding: 2px;
    border-radius: 12px;
    background: #90909029;
    backdrop-filter: blur(10px);
  }
`;
